import React from 'react';
import { CREDITS_SINGLE_FORMAT } from '../constants';

const Footer: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="relative z-10 border-t border-slate-800 bg-black/40 backdrop-blur-sm">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="mb-3">
              <img
                src="/logo.png"
                alt="PropertyCuts"
                className="h-[30px] w-auto object-contain object-left"
              />
            </div>
            <p className="text-xs text-slate-500 leading-relaxed">
              Choose landscape or portrait, add photos and clips, and export an MP4. Property details are optional.
            </p>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-xs font-semibold text-teal-300 uppercase tracking-wider mb-3">
              Product
            </h4>
            <ul className="space-y-2 text-xs text-slate-500">
              <li>Landscape and portrait</li>
              <li>Timeline editing</li>
              <li>Optional titles and branding</li>
              <li>Your music, or a licensed track</li>
            </ul>
          </div>

          {/* Pricing */}
          <div>
            <h4 className="text-xs font-semibold text-teal-300 uppercase tracking-wider mb-3">
              Pricing
            </h4>
            <ul className="space-y-2 text-xs text-slate-500">
              <li className="flex items-center gap-1.5">
                <span className="w-1.5 h-1.5 bg-green-400 rounded-full" />
                10 free credits on signup
              </li>
                <li>{CREDITS_SINGLE_FORMAT} credits per export</li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-xs font-semibold text-teal-300 uppercase tracking-wider mb-3">
              Company
            </h4>
            <ul className="space-y-2 text-xs text-slate-500">
              <li>
                <a
                  href="https://hub.rehub.studio"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-teal-300 transition-colors"
                >
                  ReHub Studio
                </a>
              </li>
              <li>
                <a
                  href="https://hub.rehub.studio/#/contact"
                  className="hover:text-teal-300 transition-colors"
                >
                  Contact
                </a>
              </li>
              <li>
                <a
                  href="https://rehub.studio/terms"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-teal-300 transition-colors"
                >
                  Terms
                </a>
              </li>
              <li>
                <a
                  href="https://rehub.studio/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-teal-300 transition-colors"
                >
                  Privacy
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-6 border-t border-slate-800/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[11px] text-slate-600">
            © {year} ReHub Studio. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-[11px] text-slate-600">
            <span>Part of the ReHub Suite</span>
            <span className="text-slate-700">·</span>
            <span>One account, all apps</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
